import ExcelJS from "exceljs";
import {
  downloadWorkbook,
  getCompanyName,
  styleLightHeader,
  applyDataBorder,
  addTitleBlock,
  applyHeaderBasedColumnWidths,
  REPORT_COLORS,
} from "./payrollReportExcelShared";

function roundDays(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return 0;
  return Math.round(x * 100) / 100;
}

/** LOP list for the payroll Attendance step. H in LOP dates means a half day. */
export async function exportLopAttendanceExcel({ rows = [], monthLabel = "" } = {}) {
  if (!rows.length) throw new Error("No LOP rows to export");

  const headers = [
    "Sl. No",
    "Code",
    "Name",
    "Leave balance",
    "LOP days",
    "LOP dates",
    "Pay days",
  ];
  const wb = new ExcelJS.Workbook();
  wb.creator = "PaceHRM";
  wb.created = new Date();
  const ws = wb.addWorksheet("LOP days", {
    views: [{ state: "frozen", ySplit: 5 }],
  });
  addTitleBlock(
    ws,
    getCompanyName(),
    `Attendance LOP — ${monthLabel || "Pay month"}`,
    `H = half day   |   Leave balance = paid leave still left under the leave policy   |   Pay days = service days minus unpaid days   |   ${new Date().toLocaleString("en-IN")}`,
    headers.length
  );
  const header = ws.addRow(headers);
  header.height = 22;
  header.eachCell((cell) => styleLightHeader(cell, REPORT_COLORS.attendance));

  rows.forEach((r, i) => {
    const line = ws.addRow([
      i + 1,
      r.empCode || "",
      r.name || "",
      roundDays(r.leaveBalance),
      roundDays(r.days),
      r.lopDates || "",
      roundDays(r.payDays),
    ]);
    line.eachCell((cell, col) => {
      applyDataBorder(cell);
      cell.alignment = { vertical: "middle", horizontal: col === 6 ? "left" : "center" };
      cell.font = { size: 10, color: { argb: "FF111827" } };
      if (col === 4 && Number(cell.value) > 0) {
        cell.font = { size: 10, bold: true, color: { argb: "FFB45309" } };
        cell.numFmt = "0.##";
      }
      if (col === 5) {
        cell.font = { size: 10, bold: true, color: { argb: "FFDC2626" } };
        cell.numFmt = "0.##";
      }
      if (col === 4 || col === 7) cell.numFmt = "0.##";
    });
  });

  applyHeaderBasedColumnWidths(ws, headers, { min: 12, max: 42 });
  ws.getColumn(6).width = 36;

  const safe = String(monthLabel || "month").replace(/[^\w.-]+/g, "_");
  return downloadWorkbook(wb, `Attendance_LOP_${safe}.xlsx`);
}
